<template>
  <div>
    <page-header
      left-side-class="col-xl-4"
      :page="pageConfig"
      right-side-class="col-xl-8 align-items-end d-flex pb-2 justify-content-end"
    >
      <template #customActions>
        <div class="row">
          <div class="col d-flex justify-content-end align-items-center">
            <action-button
              i="fas fa-arrow-circle-left"
              text="Regresar"
              variant="outline-success"
              @click="$router.go(-1)"
            />
            <action-button
              v-if="showMoveToPending"
              i="fas fa-undo-alt"
              text="Mover a Pendiente"
              variant="outline-success ml-3"
              @click="moveToPendingHandler"
            />
            <action-button
              v-if="showPayJournal"
              i="fas fa-check-circle"
              text="Pagar Jornal"
              variant="success ml-3"
              @click="processPaymentJournal"
            />
            <action-button
              v-if="showMarkAsProcessed"
              i="fas fa-check-circle"
              text="Marcar Procesado"
              variant="success ml-3"
              @click="markAsProcessedHandler"
            />
            <action-button
              v-if="showApproveBtn"
              i="fas fa-check"
              text="Aprobar pagos"
              variant="success ml-3"
              @click="onApproveHandler"
            />
            <action-button
              v-if="showUpdateJournal"
              i="fas fa-exchange-alt"
              text="Actualizar Jornal"
              variant="outline-success ml-3"
              @click="onUpdateJournalHandler"
            />
            <div v-if="showProcessPayment" class="dropdown d-flex ml-3">
              <action-button
                id="action-dropdown"
                aria-expanded="false"
                aria-haspopup="true"
                class="pt-1 success"
                data-toggle="dropdown"
                type="button"
              >
                <i class="fas fa-folders mt-1" />
                <span class="px-2">Archivos de Pagos</span>
                <i class="fa fa-angle-down" />
              </action-button>
              <div
                aria-labelledby="action-dropdown"
                class="dropdown-menu dropdown-menu-right"
              >
                <div
                  class="dropdown-item cursor-pointer"
                  @click="onProcessPaymentHandler"
                >
                  <em class="fas fa-flag pr-2 text-green" />
                  <span>Procesar Archivos de Pagos</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </page-header>

    <payment-journal-process
      v-if="showPaymentProcess"
      @on-cancel="onCancelPaymentProcessHandler"
      @on-continue="onContinuePaymentProcessHandler"
    />

    <budget-info v-model="budgetInfo" />

    <journal-info
      v-model="journalInfo"
      class="mt-2"
      @remove-files="onRemoveFilesHandler"
      @restart-status="onRestartStatusHandler"
    />

    <payment-file-info
      v-if="showPaymentFileInfo"
      class="mt-5"
      :payment-journal-id="paymentJournalId"
      :payment-journal-status-id="journalInfo.paymentJournalStatusId"
    />

    <payment-info
      ref="paymentInfoComponentRef"
      v-model="journalInfo"
      class="mt-5"
      @items-checked="onItemsCheckedHandler"
      @on-denegate-item="onDenegateHandler"
      @on-tab-changed="onTabChangedHandler"
    />
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import {
  BudgetInfo,
  JournalInfo,
  PaymentInfo,
  PaymentFileInfo,
  PaymentJournalProcess,
} from './components/details';
import {
  getPaymentJournalBudgetDetail as _getPaymentJournalBudgetDetail,
  getPaymentJournalInfoDetail as _getPaymentJournalInfoDetail,
  denyJournalPayment as _denyJournalPayment,
  approveJournalPayments as _approveJournalPayments,
  hasJournalAnswerFilesUploaded as _hasJournalAnswerFilesUploaded,
  setPaymentJournalAsPaid as _setPaymentJournalAsPaid,
  changePaymentJournalToNew as _changePaymentJournalToNew,
  updatePaymentJournal as _updatePaymentJournal,
  createPaymentInterfaceFiles as _createPaymentInterfaceFiles,
  movePaymentsToPending as _movePaymentsToPending,
  removefilesFromJournalPayments as _removefilesFromJournalPayments,
  changePaymentJournalToProcessed as _changePaymentJournalToProcessed,
} from '@/modules/shared/scholarship.api.js';
import paymentJournalStatus from '@/utils/constants/paymentJournalStatus.js';
import alertMixin from 'utils/mixins/alert.mixin.js';

export default {
  name: 'Details',
  components: {
    PageHeader,
    BudgetInfo,
    JournalInfo,
    PaymentInfo,
    PaymentFileInfo,
    PaymentJournalProcess,
  },
  mixins: [alertMixin],
  data() {
    return {
      budgetInfo: {},
      journalInfo: {},
      showPaymentProcess: false,
      academicYearId: null,
      paymentJournalId: null,
      itemsChecked: [],
      tabIndex: 0,
    };
  },
  computed: {
    pageConfig() {
      return {
        icon: 'fas fa-book',
        title: 'Detalle de Jornal de Pagos',
        routes: ['Inicio', 'Becas', 'Jornal de Pagos'],
      };
    },
    pageActionConfig() {
      return [
        {
          text: 'Crear Jornal',
          icon: 'fas fa-file-plus',
          variant: 'success',
          click: this.onCreateHandler,
          class: 'mt-4',
          visible: this.userHasPermissions(
            'menu.scholarship.jornalpayment.create'
          ),
        },
      ];
    },
    showProcessPayment() {
      return (
        this.userHasPermissions(
          'menu.scholarship.jornalpayment.processpayment'
        ) &&
        this.journalInfo.paymentJournalStatusId ===
          paymentJournalStatus.Procesado
      );
    },
    showApproveBtn() {
      return (
        this.tabIndex === 0 &&
        this.userHasPermissions(
          'menu.scholarship.jornalpayment.approvepayments'
        ) &&
        this.journalInfo.paymentJournalStatusId !=
          paymentJournalStatus.ArchivoGenerado
      );
    },
    showPayJournal() {
      return (
        this.journalInfo.paymentJournalStatusId ===
        paymentJournalStatus.ArchivoGenerado
      );
    },
    showPaymentFileInfo() {
      return [
        paymentJournalStatus.Pagado,
        paymentJournalStatus.ArchivoGenerado,
      ].includes(this.journalInfo.paymentJournalStatusId);
    },
    showProcessPaymentOption() {
      return [paymentJournalStatus.Nuevo].includes(
        this.journalInfo.paymentJournalStatusId
      );
    },
    showMoveToPending() {
      return (
        this.userHasPermissions(
          'menu.scholarship.jornalpayment.movepaymentstopending'
        ) &&
        this.journalInfo.paymentJournalStatusId ===
          paymentJournalStatus.Nuevo &&
        this.tabIndex == 1
      );
    },
    showMarkAsProcessed() {
      return (
        this.journalInfo.paymentJournalStatusId ===
          paymentJournalStatus.Nuevo &&
        this.journalInfo.pendingCount === 0 &&
        this.journalInfo.processedCount > 0
      );
    },
    showUpdateJournal() {
      return (
        this.journalInfo.paymentJournalStatusId == paymentJournalStatus.Nuevo &&
        this.userHasPermissions('menu.scholarship.jornalpayment.updatepayments')
      );
    },
  },
  async mounted() {
    const { academicYearId, paymentJournalId } = this.$route.params;
    if (academicYearId && paymentJournalId) {
      this.academicYearId = academicYearId;
      this.paymentJournalId = paymentJournalId;

      await this.getPaymentJournalBudgetDetails(academicYearId);
      await this.getPaymentJournalInfoDetails(paymentJournalId);
    }
  },
  methods: {
    async onApproveHandler() {
      if (this.itemsChecked.length > 0) {
        //validate eligible students
        const hasNotEligiblePayment = this.$refs.paymentInfoComponentRef.validateEliglePayments();
        if (hasNotEligiblePayment) {
          this.ShowToast(
            '',
            'No es posible aprobar los pagos, ya que cuenta con estudiante(s) no elegible(s) para Becas de Transportación de acuerdo a los PEI’s firmados en el sistema.',
            'error'
          );
          return;
        }

        const answer = await this.ShowCancelModal(
          'Confirmación',
          '¿Está seguro que desea aprobar el(los) pago(s) seleccionado(s) del Jornal de Pagos?',
          'Sí',
          'No'
        );

        if (answer) {
          await _approveJournalPayments(
            this.paymentJournalId,
            this.itemsChecked
          )
            .then(() => {
              this.updateInfo();
              this.ShowToast(
                '',
                'El(los) pago(s) fueron Aprobados exitosamente.',
                'success'
              );
            })
            .catch((error) => {
              this.ShowToast('', error, 'error');
            });
        }
      } else {
        this.ShowToast(
          'Alerta',
          'Debe tener al menos un record seleccionado para ejecutar esta acción.',
          'error'
        );
      }
    },
    async onDenegateHandler(assistanceSummaryId, comment) {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea denegar el pago seleccionado del Jornal de Pagos?',
        'Sí',
        'No'
      );

      if (answer) {
        let payload = {
          id: assistanceSummaryId,
          value: comment,
        };

        await _denyJournalPayment(parseInt(this.paymentJournalId), payload)
          .then(() => {
            this.updateInfo();
            this.ShowToast(
              'Proceso exitoso',
              'El pago fue Denegado exitosamente.',
              'success'
            );
          })
          .catch((error) => {
            this.ShowToast('', error, 'error');
          });
      }
    },
    async getPaymentJournalBudgetDetails(academicYearId) {
      const { data: response } = await _getPaymentJournalBudgetDetail(
        academicYearId
      );
      this.budgetInfo = response;
    },
    async getPaymentJournalInfoDetails(paymentJournalId) {
      const { data: response } = await _getPaymentJournalInfoDetail(
        paymentJournalId
      );
      this.journalInfo = response;
    },
    async onProcessPaymentHandler() {
      const { data: response } = await _createPaymentInterfaceFiles(
        this.paymentJournalId
      );
      if (response) {
        this.onRefreshPaymentJournal();
      }
    },
    async processPaymentJournal() {
      const { data: validationResponse } = await _hasJournalAnswerFilesUploaded(
        this.paymentJournalId
      );
      if (!validationResponse) {
        this.ShowToast(
          'Alerta',
          'El jornal no cuenta con los archivos de respuestas correspondientes para proceder con esta acción.',
          'error'
        );
        return;
      }
      this.showPaymentProcess = true;
    },
    async onContinuePaymentProcessHandler(model) {
      const { data: response } = await _setPaymentJournalAsPaid(
        this.paymentJournalId,
        model.paymentDate
      );
      if (response) {
        this.ShowToast(
          '',
          'El pago ha sido realizado exitosamente.',
          'success'
        );
        this.onCancelPaymentProcessHandler();
        this.onRefreshPaymentJournal();
      }
    },
    onRefreshPaymentJournal() {
      this.getPaymentJournalInfoDetails(this.paymentJournalId);
    },
    onCancelPaymentProcessHandler() {
      this.showPaymentProcess = false;
    },
    onItemsCheckedHandler(items) {
      this.itemsChecked = items;
    },
    onTabChangedHandler(tabIndex) {
      this.tabIndex = tabIndex;
    },
    updateInfo() {
      this.getPaymentJournalBudgetDetails(this.academicYearId);
      this.getPaymentJournalInfoDetails(this.paymentJournalId);
      this.$refs.paymentInfoComponentRef.callPendingPaymentDetail();
      this.$refs.paymentInfoComponentRef.callProcessedPaymentDetail();
    },
    async onRestartStatusHandler() {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea actualizar el estatus del Jornal de Procesado a Nuevo?',
        'Sí',
        'No'
      );
      if (answer) {
        const { data: response } = await _changePaymentJournalToNew(
          this.paymentJournalId
        );
        if (response) {
          this.ShowToast(
            '',
            'El Estatus del Jornal ha sido actualizado exitosamente.',
            'success'
          );
          this.onRefreshPaymentJournal();
        }
      }
    },
    async onUpdateJournalHandler() {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea actualizar el  Jornal de Pago?',
        'Sí',
        'No'
      );
      if (answer) {
        const { data: updateResponse } = await _updatePaymentJournal(
          this.paymentJournalId
        );
        if (updateResponse) {
          this.ShowToast(
            '',
            'Jornal de Pago actualizado exitosamente.',
            'success'
          );
          this.updateInfo();
        }
      }
    },
    async onRemoveFilesHandler() {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea eliminar los Archivos de Pagos generados?',
        'Sí',
        'No'
      );
      if (answer) {
        const { data: removeResponse } = await _removefilesFromJournalPayments(
          this.paymentJournalId
        );
        if (removeResponse) {
          this.ShowToast(
            '',
            'Archivos de Pagos eliminados exitosamente.',
            'success'
          );
          this.updateInfo();
        }
      }
    },
    async moveToPendingHandler() {
      if (this.itemsChecked.length == 0) {
        this.ShowToast(
          'Alerta',
          'Al menos un record debe ser seleccionado para completar esta acción.',
          'error'
        );
        return;
      }

      const answer = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea actualizar a Pendiente el(los) pago(s) seleccionado(s)?',
        'Sí',
        'No'
      );
      if (answer) {
        const { data: response } = await _movePaymentsToPending(
          this.paymentJournalId,
          [...this.itemsChecked]
        );
        if (response) {
          this.ShowToast('', 'Pago(s) actualizado(s) exitosamente.', 'success');
          this.updateInfo();
        }
      }
    },
    async markAsProcessedHandler() {
      const answer = await this.ShowCancelModal(
        'Confirmación',
        '¿Está seguro que desea marcar como Procesado el Jornal de Pago?',
        'Sí',
        'No'
      );
      if (answer) {
        await _changePaymentJournalToProcessed(this.paymentJournalId);
        this.ShowToast(
          '',
          'Estatus de Jornal actualizado exitosamente.',
          'success'
        );
        this.onRefreshPaymentJournal();
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/shared/scss/config/_colors.scss';
.dropdown-solid {
  background-color: map-get($colors, 'secondary-22');
  border: 1px solid map-get($colors, 'secondary-22');
  color: #fff;
  font-weight: 400;
  width: auto;
  height: 38px;
}
</style>
